// extracted by mini-css-extract-plugin
export default {"sidebar_menu":"Sidebar_sidebar_menu__vm8D+","active":"Sidebar_active__eROQD"};